<template>
    <i class="cursor-pointer text-white ds-text-xl p-1" :class="iconClass" @click="$emit('click')" />
</template>

<script>
    export default {
        props: {
            iconClass: { type: String, required: true },
        }
    }
</script>
